import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ApiService from '../services/api';
import { API_ENDPOINTS } from '../config/api';
import './Home.css';

function Home() {
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await ApiService.post(API_ENDPOINTS.AUTH.REGISTER, formData);
      if (response.success) {
        setSuccess(true);
        setTimeout(() => navigate('/treinamentos'), 4000);
      }
    } catch (err) {
      setError(err.message || 'Erro ao cadastrar');
    } finally {
      setLoading(false);
    }
  };

  const LogoIcon = () => (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="home-grad" cx="38%" cy="32%" r="72%">
          <stop offset="0%"  stopColor="#e09050"/>
          <stop offset="40%" stopColor="#c4722a"/>
          <stop offset="100%" stopColor="#5c1f06"/>
        </radialGradient>
      </defs>
      <circle cx="100" cy="100" r="92" fill="url(#home-grad)"/>
      <circle cx="100" cy="100" r="92" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="1.8"/>
      <path d="M 72,76  C 66,68 78,60 72,52" stroke="rgba(255,255,255,0.72)" strokeWidth="3.6" strokeLinecap="round"/>
      <path d="M 100,72 C 94,64 106,56 100,48" stroke="rgba(255,255,255,0.72)" strokeWidth="3.6" strokeLinecap="round"/>
      <path d="M 128,76 C 122,68 134,60 128,52" stroke="rgba(255,255,255,0.72)" strokeWidth="3.6" strokeLinecap="round"/>
      <path d="M 55,82 L 62,132 H 138 L 145,82 Z" fill="rgba(255,255,255,0.09)" stroke="rgba(255,255,255,0.92)" strokeWidth="3.6" strokeLinejoin="round"/>
      <ellipse cx="100" cy="82" rx="45" ry="10" fill="rgba(48,14,2,0.92)" stroke="rgba(255,255,255,0.18)" strokeWidth="1.4"/>
      <ellipse cx="90" cy="80" rx="14" ry="3.5" fill="rgba(255,255,255,0.06)"/>
      <path d="M 138,93 Q 165,93 165,108 Q 165,123 138,123" stroke="rgba(255,255,255,0.92)" strokeWidth="3.6" fill="none" strokeLinecap="round"/>
      <ellipse cx="100" cy="138" rx="54" ry="9.5" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.62)" strokeWidth="2.6"/>
    </svg>
  );

  if (success) {
    return (
      <div className="home-page">
        <div className="home-left">
          <div className="home-orbs">
            <div className="home-orb home-orb-1"/>
            <div className="home-orb home-orb-2"/>
          </div>
          <div className="home-brand">
            <div className="home-brand-logo"><LogoIcon/></div>
            <h1>Cloud Cafe<br/><span>&</span> DevOps</h1>
            <p className="home-brand-desc">Sua jornada no domínio da Cloud e DevOps começa aqui.</p>
          </div>
        </div>
        <div className="home-right">
          <div className="home-success">
            <div className="home-success-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h2>Cadastro realizado!</h2>
            <p>Enviamos um código de acesso para seu e-mail.</p>
            <p>Use o código para fazer seu primeiro login.</p>
            <p className="home-redirect">Redirecionando para o login...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      <div className="home-left">
        <div className="home-orbs">
          <div className="home-orb home-orb-1"/>
          <div className="home-orb home-orb-2"/>
        </div>
        <div className="home-brand">
          <div className="home-brand-logo"><LogoIcon/></div>
          <h1>Cloud Cafe<br/><span>&</span> DevOps</h1>
          <p className="home-brand-desc">
            Transforme sua carreira com os melhores cursos de Cloud e DevOps.
            Aprenda no seu ritmo, conquiste certificações.
          </p>
          <div className="home-features">
            <div className="home-feat">Cursos gratuitos e pagos</div>
            <div className="home-feat">Certificados digitais reconhecidos</div>
            <div className="home-feat">Comunidade exclusiva de devs</div>
            <div className="home-feat">Plano de estudos personalizado</div>
          </div>
        </div>
      </div>

      <div className="home-right">
        <div className="home-card">
          <h2>Criar conta</h2>
          <p className="home-card-sub">Preencha abaixo e comece gratuitamente</p>

          {error && <div className="home-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="home-field">
              <label>Nome completo</label>
              <input
                type="text"
                placeholder="Seu nome completo"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                disabled={loading}
              />
            </div>
            <div className="home-field">
              <label>E-mail</label>
              <input
                type="email"
                placeholder="seu@email.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                disabled={loading}
              />
            </div>
            <button type="submit" className="home-btn" disabled={loading}>
              {loading ? 'Criando conta...' : 'Criar conta grátis'}
            </button>
          </form>

          <p className="home-login-link">
            Já tem conta? <Link to="/treinamentos">Faça login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
